import * as React from 'react';
import { Responsive, UIHeading3, UIHeading4, UIHeading2, UIText2 } from '@cian/ui-kit';

import * as styles from './ProjectCard.css';
import { ResponsiveImage } from '../ResponsiveImage';
import { ProjectPrice } from '../ProjectPrice';
import { ProjectParameters } from '../ProjectParameters';
import { IImage } from '../../types/builder';

export interface IProjectCardProps {
  images: IImage[];
  name: string;
  area?: string;
  floors?: string;
  materials?: string;
  startPrice?: string;
  hasMansard?: boolean;
  onClick(): void;
}

export const ProjectCard: React.FC<IProjectCardProps> = ({
  images,
  name,
  area,
  floors,
  materials,
  startPrice,
  onClick,
}) => {
  const image = images[0];

  return (
    <div className={styles['container']} onClick={onClick}>
      <ResponsiveImage src={image?.thumbnail} />
      <div className={styles['content']}>
        <Responsive desktop>
          <UIHeading3 color="primary_100">{name}</UIHeading3>
        </Responsive>
        <Responsive tablet phone>
          <UIHeading4 color="primary_100">{name}</UIHeading4>
        </Responsive>
        {startPrice && (
          <div className={styles['price']}>
            <UIHeading2>
              <ProjectPrice start={startPrice} />
            </UIHeading2>
          </div>
        )}
        <div className={styles['parameters']}>
          <UIText2>
            <ProjectParameters area={area} floors={floors} materials={materials} hideOverflow />
          </UIText2>
        </div>
      </div>
    </div>
  );
};
